<div *ngIf="showResetFilters" class="reset-filters-row">
    <button (click)="clearGridFilters()">
        {{ 'components.gridState.removeFilters' | transloco }}
    </button>
</div>
